import { storage } from '../config';

const has = Object.prototype.hasOwnProperty;
const markerTypeMap = new Map([
  ['sites', 'Site Marker'],
  ['buildings', 'Building Marker'],
]);

export function getIconByType(type, markers) {
  if (
    markerTypeMap.has(type) &&
    has.call(markers, 'buildingsAndSites') === true
  ) {
    const customMarker = markers.buildingsAndSites.find(val => {
      return val.name === markerTypeMap.get(type);
    });
    if (customMarker !== undefined) {
      return `${storage.cloudStoragePath}/${customMarker.filename}`;
    }
  }

  return undefined;
}

export function getIconByBuildingSpecialtyFeatures(property, type, markers) {
  if (
    type === 'buildings' &&
    has.call(property, 'specialtyFeatures') === true &&
    property.specialtyFeatures.length > 0 &&
    has.call(markers, 'buildingSpecialityFeatures') === true
  ) {
    const [featureForIcon] = property.specialtyFeatures;
    const customMarker = markers.buildingSpecialityFeatures.find(val => {
      return val.name === featureForIcon;
    });
    if (customMarker !== undefined) {
      return `${storage.cloudStoragePath}/${customMarker.filename}`;
    }
  }

  return undefined;
}

export function getIconBySiteCertification(property, type, markers) {
  if (
    type === 'sites' &&
    has.call(property, 'siteCertified') === true &&
    property.siteCertified === 1 &&
    has.call(markers, 'certifiedSites') === true
  ) {
    const customMarker = markers.certifiedSites.find(val => {
      return val.name === 'Certified Site Marker';
    });
    if (customMarker !== undefined) {
      return `${storage.cloudStoragePath}/${customMarker.filename}`;
    }
  }

  return undefined;
}

// Checks if a given property has certain specialtyFeatures
// Returns the icon corresponding to the specified specialtyFeature custom marker
export function getIconBySiteSpecialtyFeatures(property, type, markers) {
  if (
    type === 'sites' &&
    has.call(property, 'specialtyFeatures') === true &&
    property.specialtyFeatures.length > 0 &&
    has.call(markers, 'siteSpecialityFeatures') === true
  ) {
    const [featureForIcon] = property.specialtyFeatures;
    const customMarker = markers.siteSpecialityFeatures.find(val => {
      return val.name === featureForIcon;
    });
    if (customMarker !== undefined) {
      return `${storage.cloudStoragePath}/${customMarker.filename}`;
    }
  }

  return undefined;
}

export function getIconByMapLayer(layer, defaultIcon, markers) {
  const customMarker = (
    markers &&
    markers.mapLayers &&
    markers.mapLayers.find(l => l.name === layer)
  ) || {};

  return `${storage.cloudStoragePath}/${customMarker.filename || defaultIcon}`;
}

export default function getPropertyIcon(property, type, defaultIcon, markers) {
  const featureIcon = getIconByBuildingSpecialtyFeatures(property, type, markers);
  if (featureIcon !== undefined) {
    return featureIcon;
  }

  const siteFeatureIcon = getIconBySiteSpecialtyFeatures(property, type, markers);
  if (siteFeatureIcon !== undefined) {
    return siteFeatureIcon;
  }

  const siteCertifiedIcon = getIconBySiteCertification(property, type, markers);
  if (siteCertifiedIcon !== undefined) {
    return siteCertifiedIcon;
  }

  const typeIcon = getIconByType(type, markers);
  if (typeIcon !== undefined) {
    return typeIcon;
  }

  return defaultIcon;
}



// WEBPACK FOOTER //
// ./src/utils/getPropertyIcon.js